module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-pannel"
  }, [_c('div', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasHeaderSlot),
      expression: "hasHeaderSlot"
    }],
    staticClass: "mt-pannel__header",
    class: {
      borderBottom: _vm.headerBorderBottom
    }
  }, 'div', _vm.headerCustomAttr, false), [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "mt-pannel__body",
    style: ({
      height: _vm.bodyHeight
    })
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasVerticalSlot),
      expression: "hasVerticalSlot"
    }],
    staticClass: "mt-pannel--vertical"
  }, [_c('div', {
    staticClass: "mt-pannel--vertical__middle"
  }, [_c('div', {
    staticClass: "mt-pannel--vertical__inner"
  }, [_vm._t("vertical")], 2)])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee04ecb","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/pannel/Pannel.vue
// module id = goGi
// module chunks = 0